import ContentCategoryMenu from './contentCategoryMenu'

export default ContentCategoryMenu
